import { ErrorMessage, Field, FormikContextType, FormikValues, getIn, useField, useFormikContext } from 'formik';
import React, { Fragment, type JSX } from 'react';

interface CheckboxProps {
  name: string;
  label: any; // can contain html so simply string does not work
  validate?: (value: string) => string;
}

/**
 * React checkbox field helper with build in error message.
 *
 * @example
 * <Checkbox name="newsletter"
 *           label="Ik ontvang graag de Lyceo Nieuwsbrief"/>
 */
export const Checkbox = (props: CheckboxProps): JSX.Element => {
  const meta = useField(props)[1];
  const { values }: FormikContextType<FormikValues> = useFormikContext();
  const { name, label, validate }: CheckboxProps = props;
  const hasError: boolean = (!!meta.touched && !!meta.error);

  let cssClasses: string = 'bem-checkbox__label';

  if (hasError) {
    cssClasses += ' error';
  }

  if (getIn(values, name)) {
    cssClasses += ' checked';
  }

  return (
    <Fragment>
      <label className={cssClasses}>
        <Field type="checkbox"
          className="bem-checkbox"
          name={name}
          validate={validate} />
        {label}
      </label>
      <ErrorMessage name={name}
        component="div"
        className="validation-error"/>
    </Fragment>
  );
};
